<!--  -->
<template>
  <div class="FloatingWindow">
    <div ref="loan" @click="loanFn" class="loan baseStyle">
      <img src="@/assets/images/orderMin.png" alt="" class="imgStyle" />
    </div>
    <div ref="setting" @click="settingFn" class="setting baseStyle">
      <img src="@/assets/images/personalIconMin.png" alt="" class="imgStyle" />
    </div>
    <div ref="home" @click="homeFn" class="home baseStyle">
      <img src="@/assets/images/homeMin.png" alt="" class="imgStyle" />
    </div>
    <div ref="operation" @click="operation" class="operation baseStyle">
      <img :src="operationIcon" alt="" class="operationIcon" />
    </div>
  </div>
</template>

<script>
import Xuanfu from '@/assets/images/xuanfutu.png';
import XuanfuClose from '@/assets/images/xuanfushan.png';

export default {
  name: 'FloatingWindow',
  data() {
    return {
      flag: false,
      operationIcon: Xuanfu,
    };
  },
  methods: {
    operation(e) {
      e.stopPropagation();
      if (!this.flag) {
        this.operationIcon = XuanfuClose;
        this.flag = true;
        this.$refs.setting.style.transform = 'translate(0px, -74px) scale(1)';
        this.$refs.loan.style.transform = 'translate(-51px, -51px) scale(1)';
        this.$refs.home.style.transform = 'translate(-74px, 0px) scale(1)';
        this.$refs.operation.style.transform = 'scale(0.8)';
      } else {
        this.operationIcon = Xuanfu;
        this.flag = false;
        this.$refs.home.style.transform = 'translate(0px, 0px) scale(0)';
        this.$refs.loan.style.transform = 'translate(0px, 0px) scale(0)';
        this.$refs.setting.style.transform = 'translate(0px, 0px) scale(0)';
        this.$refs.operation.style.transform = 'scale(1)';
      }
    },
    homeFn(e) {
      e.stopPropagation();
      this.$router.push('/supermarket/v2/');
    },
    loanFn(e) {
      e.stopPropagation();
      window.location.href = '/backloansuper/loan/supermarket/login2Url/v1.0?k=myLoad';
    },
    settingFn(e) {
      e.stopPropagation();
      window.location.href = '/backloansuper/loan/supermarket/login2Url/v1.0?k=personalCenter';
    },
  },
};
</script>
<style scoped>
.FloatingWindow {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  position: fixed;
  bottom: 30px;
  right: 10px;
  z-index: 999;
}
.baseStyle {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  position: absolute;
  top: 0;
  left: 0;
  box-shadow: 0 2px 24px 0 rgba(0, 0, 0, 0.16);
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
}
.baseStyle .operationIcon {
  width: 100%;
  height: 100%;
}
.baseStyle .imgStyle {
  width: 20px;
  height: 20px;
}
.home {
  transition: transform 0.6s;
  transform: translate(0px, 0px) scale(0);
}
.operation {
  transition: transform 0.6s;
  transform: scale(1);
}
.loan {
  transition: transform 0.6s;
  transform: translate(0px, 0px) scale(0);
}
.setting {
  transition: transform 0.6s;
  transform: translate(0px, 0px) scale(0);
}
</style>
